import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';
import { first } from 'lodash-es';
import { Observable, of } from 'rxjs';

import { IPhaseI18n } from 'phase/phase-i18n';

import { SectionType } from '../../../application/phase/model/section/section.type';
import { ISectionI18n, SectionI18n } from './section-i18n';

export interface ISection extends IEntity {
	readonly phaseId: string;
	readonly position: number;
	readonly type: SectionType;
	readonly localizations: ReadonlyArray<ISectionI18n>;
	readonly localization$: Observable<ISectionI18n>;
	localization(language: string): ISectionI18n;
}

export class Section extends Entity implements ISection {
	private _phaseId: string;
	private _position: number;
	private _type: SectionType;
	private _localizations: SectionI18n[];
	private _localization$: Observable<SectionI18n>;

	constructor(
		id: string,
		phaseId: string,
		position: number,
		type: SectionType,
		updateTimestamp: number,
		localizations: SectionI18n[],
		localization$: Observable<SectionI18n> = of(null)
	) {
		super(id, null, updateTimestamp);
		this._phaseId = phaseId;
		this._position = position;
		this._type = type;
		this._localizations = localizations;
		this._localization$ = localization$;
	}

	public get phaseId(): string {
		return this._phaseId;
	}

	public get position(): number {
		return this._position;
	}

	public get type(): SectionType {
		return this._type;
	}

	public get localizations(): SectionI18n[] {
		return this._localizations;
	}

	public get localization$(): Observable<SectionI18n> {
		return this._localization$;
	}

	public localization(language: string): ISectionI18n {
		return (
			this._localizations.find((l) => l.locale === language) ??
			first(this._localizations)
		);
	}
}
